import React from "react";
import PageHero from "../components/PageHero";
import { PROGRAMS } from "../mock/mock";
import { useContent } from "../context/ContentContext";
import CTASection from "../components/CTASection";

export default function Programs() {
  const { programs = PROGRAMS } = useContent();
  return (
    <>
      <PageHero
        kicker="PROGRAMLAR"
        title="Destek ve teşvik programları."
        subtitle="Devlet kurumları ve kalkınma ajansları tarafından sunulan başlıca destek programlarına genel bir bakış."
      />
      <section className="py-20 lg:py-28 bg-[#0a0a0a]">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-5">
          {programs.map((p, i) => (
            <div key={i} className="border border-[#B87333]/20 bg-[#0d0b09] p-10 hover:border-[#B87333] transition-colors duration-500">
              <div className="flex items-center justify-between mb-6">
                <span className="font-serif-display text-[#B87333] text-4xl">{p.code}</span>
                <span className="text-[11px] tracking-[0.3em] text-[#a89a85]">0{i + 1}</span>
              </div>
              <h3 className="font-serif-display text-[#f5ede1] text-2xl leading-snug mb-4">{p.title}</h3>
              <p className="text-[#a89a85] text-sm leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </section>
      <CTASection />
    </>
  );
}
